import { GetUserProfileQuery } from '@/graphql/GetUserProfile.generated';

import { appStore } from './appStore';

const { VITE_APP_DEFAULT_CURRENCY, VITE_APP_DEFAULT_LOCALE } = import.meta.env;

type AppUserRole = 'public' | 'fleet-manager' | 'admin';

const AppUserRoleLabels = {
  public: 'Public',
  'fleet-manager': 'Fleet manager',
  admin: 'Administrator',
};

const getRoleLabel = (role: AppUserRole) => AppUserRoleLabels[role];

// avoid conflict name with auth0 User type
interface AppUser {
  id: string;
  email: string;
  company: string;
  role: AppUserRole;
  locale: string;
  currency: string;
  firstname: string | null;
  lastname: string | null;
  avatar: string | null;
  displayName: string;
}

function setAppUser(
  user: GetUserProfileQuery['container_insights_users_by_pk'],
) {
  if (user) {
    const {
      id,
      email,
      company,
      role,
      locale,
      currency,
      first_name,
      last_name,
      avatar,
    } = user;

    appStore.user = {
      id,
      email,
      company,
      locale: locale || VITE_APP_DEFAULT_LOCALE,
      currency: currency || VITE_APP_DEFAULT_CURRENCY,
      role: role as AppUserRole,
      firstname: first_name || null,
      lastname: last_name || null,
      avatar: avatar || null,
      get displayName() {
        return this.firstname && this.lastname
          ? `${this.firstname} ${this.lastname}`
          : this.email;
      },
    };
  }
}

export { setAppUser, getRoleLabel };
export type { AppUser, AppUserRole };
